import React from 'react';

/**
 * BrandName - renders "CLIMATECO₂RE" with the 2 as a subscript.
 * Use this wherever the brand name appears as inline text.
 */
const BrandName = ({ className = '' }) => {
  return (
    <span className={className}>
      CLIMATECO<sub>2</sub>RE
    </span>
  );
};

export default BrandName;
